<i2a-external-delegates [title]="'profile.provider.microsoft.oneDrive.external' | i18next"
    [subTitle]="" [delegates]="delegatesWithAlerts" [isAlert]="isAlert"
    [hasAlert]="hasAlert" [hasAlertRecentlyClosed]="hasAlertRecentlyClosed" (onWarnClick)="warnClick($event)"
    [resourceProfile]="resourceProfile">
</i2a-external-delegates>
